export default class JobsFilter {
  constructor() {
    this.form = document.getElementById('jobs-filter');
    this.resultsContainer = document.getElementById('jobs-results');
    this.isFiltered = false;
    
    if (!this.form || !this.resultsContainer) return;
    
    this.init();
  }

  init() {
    this.addEventListeners();
    this.handlePaginationLinks();
  }

  handlePaginationLinks() {
    this.resultsContainer.addEventListener('click', (e) => {
      const paginationLink = e.target.closest('.pagination a');
      if (paginationLink) {
        e.preventDefault();
        const url = new URL(paginationLink.href);
        const formData = new FormData(this.form);
        
        // Extrahiere die Seitennummer aus der URL
        const pageMatch = url.pathname.match(/page\/(\d+)/);
        const page = pageMatch ? pageMatch[1] : 1;
        
        // Füge die Seitennummer zu den Formulardaten hinzu
        formData.set('paged', page);
        
        // AJAX-Request durchführen
        this.filterJobs(formData);
        
        // URL aktualisieren
        const newURL = page > 1 
          ? `/jobs-karriere/page/${page}/` 
          : '/jobs-karriere/';
        history.pushState({}, '', newURL);
        
        // Entferne das automatische Scrollen
        // window.scrollTo({
        //   top: this.resultsContainer.offsetTop - 100,
        //   behavior: 'smooth'
        // });
      }
    });
  }

  handleFilterChange = () => {
    const formData = new FormData(this.form);
    
    // Setze den Filter-Status
    const location = formData.get('location');
    const jobTypes = formData.getAll('job_type[]');
    this.isFiltered = location !== '' || jobTypes.length > 0;
    
    this.filterJobs(formData);
  }

  async filterJobs(formData) {
    try {
      const params = new URLSearchParams();
      params.append('action', 'filter_jobs');
      
      // Append all form data to params
      for (const [key, value] of formData.entries()) {
        params.append(key, value);
      }

      const response = await fetch(`${wpData.ajaxUrl}?${params.toString()}`);
      const html = await response.text();
      this.resultsContainer.innerHTML = html;
    } catch (error) {
      console.error('Error filtering jobs:', error);
    }
  }

  addEventListeners() {
    this.form.addEventListener('submit', (e) => {
      e.preventDefault();
      this.handleFilterChange();
    });

    this.form.querySelector('select[name="location"]')
      .addEventListener('change', this.handleFilterChange);
      
    this.form.querySelectorAll('input[name="job_type[]"]')
      .forEach(checkbox => {
        checkbox.addEventListener('change', this.handleFilterChange);
      });
  }
}